import { AtlasEnvironment, baseEnvironment } from './base-environment';

export const environment: AtlasEnvironment = {
    ...baseEnvironment,
    production: true,
};
